<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><img alt="bird" src="image/burb.jpg"/></p>
<h1 class="center">EARLY BIRD BOOKS</h1>
<p class="center"><b>FRESH EBOOK DEALS, DELIVERED DAILY</b></p>
<p class="Basic-Paragraph" style="margin-top:20px">LOVE  <span class="Orange-Text-1">TO READ</span>?</p>
<p class="Basic-Paragraph">LOVE <span class="Orange-Text-1">GREAT SALES</span>?</p>
<p class="Basic-Paragraph-2" style="margin-top:20px;">GET <span class="Orange-Text-1">FANTASTIC</span> DEALS ON BESTSELLING EBOOKS DELIVERED TO YOUR INBOX EVERY DAY!</p>
<p class="center" style="margin-top:20px;"><a href="https://earlybirdbooks.com/?utm_source=EBBGOAAAAE&amp;utm_campaign=9781504017268" target="_blank"><img alt="signup" src="image/signup.jpg"/></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebadfront.vue?aaee7abe